import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Image, Nav } from "react-bootstrap";
import { MdLocationOn, MdOutlineInfo } from "react-icons/md";
import illusEspaces from "../../../assets/images/illusEspaces.jpg";
import { GrGroup } from "react-icons/gr";
import { usagesSalles } from "../../../constants/usagesSalles";
import { usagesDigital } from "../../../constants/usagesDigital";
import ComponentCalendrier from "./ComponentCalendrier";
import { FaTag } from "react-icons/fa";
import { RiComputerLine } from "react-icons/ri";
import { BsCalendar2Week } from "react-icons/bs";

const ComponentEspaceInfo = (props) => {
  const { t } = useTranslation();
  const { espace, tabKey, setTabKey, ongletCalendrier, calendriers, usagesDisponibles } = props;

  const usesSalles = usagesSalles;
  const usesDigital = usagesDigital;

  const scrollBloc = (ID) => {
    setTimeout(function () {
      document.getElementById(ID).scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const pointCouleur = (usages, usage, withUsage = null) => {
    let usageTrouve = usages.filter((item) => item.tag === usage)[0];

    if (usageTrouve)
      return (
        <React.Fragment key={usage}>
          <span className="pointCouleurUsage" style={{ backgroundColor: usageTrouve.color }}></span>
          {withUsage !== null ? withUsage : ""}
        </React.Fragment>
      );

    return null;
  };

  const AfficheUsage = ({ idUsage = null }) => {
    if (idUsage) {
      let usagePrincipalTrouve = usagesDisponibles.filter((item) => item._id === idUsage);
      if (usagePrincipalTrouve && usagePrincipalTrouve.length > 0)
        return <div>{usagePrincipalTrouve[0].nom}</div>;
    }
    return null;
  };

  const calendrierExist = (email) => {
    if (email) {
      const calendrierDeLaSalle = calendriers.filter((item) => item.salleAdress === email);
      if (calendrierDeLaSalle.length === 1) {
        return true;
      }
    }
    return false;
  };

  const calendrierFiltre = (email) => {
    if (email) {
      const calendrierDeLaSalle = calendriers.filter((item) => item.salleAdress === email);
      if (calendrierDeLaSalle.length === 1) {
        return calendrierDeLaSalle[0].agendaSalle;
      }
    }
    return null;
  };

  return (
    <Card border={"black"} id={espace._id} className="tablistDetailSpace">
      <Card.Header>
        <Nav
          variant="tabs"
          activeKey={tabKey}
          onSelect={(selectedKey) => {
            setTabKey(selectedKey);
            scrollBloc(espace._id);
          }}
        >
          <Nav.Item>
            <Nav.Link eventKey="informations">
              <MdOutlineInfo />
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="usages">
              <FaTag size="1em" color="#BBBBBB" className="me-1" />
              {t("public.pageTierslieux.titleColonne3")}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="connectivite">
              <RiComputerLine size="1.3em" color="#BBBBBB" className="me-1" />
              {t("public.pageTierslieux.titleColonne7")}
            </Nav.Link>
          </Nav.Item>
          {ongletCalendrier && (
            <Nav.Item>
              <Nav.Link eventKey="calendrier">
                <BsCalendar2Week size="1em" color="#BBBBBB" className="me-1" />
                {t("public.pageTierslieux.calendrier")}
              </Nav.Link>
            </Nav.Item>
          )}
        </Nav>
      </Card.Header>
      <Card.Body>
        <div style={{ flex: 1, fontSize: 12, marginLeft: 8 }}>
          <h4> {espace.nom}</h4>
          {tabKey === "informations" && (
            <div className="d-flex flex-wrap justify-content-center">
              <Image
                className="roomSmall"
                src={
                  espace.cardPic
                    ? process.env.REACT_APP_URL_EXPRESS + "images/space/small/" + espace.cardPic
                    : illusEspaces
                }
              />
              <span className="flex-grow-1 p-2">
                <p className="d-flex">
                  <MdLocationOn size="1.5em" className="me-1" />
                  <span>
                    {espace.localisation.nom ? espace.localisation.nom : "-"} <br />
                    {espace.zone ? (
                      <>
                        {espace.zone}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {espace.localisation.adresse ? espace.localisation.adresse : ""}
                  </span>
                </p>

                <p>
                  <GrGroup size="1.5em" className="me-1" />
                  {espace.capacite
                    ? espace.capacite === 1
                      ? espace.capacite + " " + t("public.pageTierslieux.personne")
                      : espace.capacite + " " + t("public.pageTierslieux.personnes")
                    : "-"}
                </p>
              </span>
            </div>
          )}
          {tabKey === "usages" && (
            <>
              <div className="d-flex flex-wrap">
                <Image
                  className="roomSmall"
                  src={
                    espace.cardPic
                      ? process.env.REACT_APP_URL_EXPRESS + "images/space/small/" + espace.cardPic
                      : illusEspaces
                  }
                />
                <div className="ms-2">
                  {espace.usages.map((idUsage, index) => (
                    <AfficheUsage key={idUsage} idUsage={idUsage} />
                  ))}

                  {espace.mainUse !== "null" && espace.mainUse ? (
                    <div>
                      {/* {pointCouleur(usesSalles, espace.mainUse)} */}
                      {t("commun.usagesSalles." + espace.mainUse)}
                    </div>
                  ) : (
                    ""
                  )}
                  {espace.secondaryUses.sort().map((use, index) => {
                    return (
                      <div key={"secondaryUse" + index}>
                        {/* {pointCouleur(usesSalles, use)} */}
                        {t("commun.usagesSalles." + use)}
                      </div>
                    );
                  })}
                </div>
              </div>

              {espace.agencements.length > 0 && (
                <>
                  <hr />
                  <span className="fw-bold">{t("public.pageTierslieux.titleColonne6")}</span>
                  <br />
                  <div className="d-flex flex-wrap justify-content-around">
                    {espace.agencements.map((photoName, index) => (
                      <Image
                        className="m-1 p-1"
                        key={"photoAgencement_" + index}
                        width={300}
                        height={169}
                        src={process.env.REACT_APP_URL_EXPRESS + "images/space/" + photoName}
                      />
                    ))}
                  </div>
                </>
              )}
            </>
          )}

          {tabKey === "connectivite" && (
            <>
              <div className="d-flex flex-wrap ">
                <Image
                  className="roomSmall"
                  src={
                    espace.cardPic
                      ? process.env.REACT_APP_URL_EXPRESS + "images/space/small/" + espace.cardPic
                      : illusEspaces
                  }
                />
                <div className="ms-2">
                  {espace.mainUseDigital !== "null" && espace.mainUseDigital ? (
                    <div>
                      {/* {pointCouleur(usesDigital, espace.mainUseDigital)} */}
                      {t("commun.usagesDigital." + espace.mainUseDigital)}
                    </div>
                  ) : (
                    ""
                  )}
                  {espace.secondaryUsesDigital.sort().map((use, index) => {
                    return (
                      <div key={"secondaryUseDigital" + index}>
                        {/* {pointCouleur(usesDigital, use)} */}
                        {t("commun.usagesDigital." + use)}
                      </div>
                    );
                  })}
                </div>
              </div>
              {espace.procedure && (
                <>
                  <hr />
                  <span className="fw-bold">{t("public.pageTierslieux.titleColonne4")}</span>
                  <br />
                  <p className="whiteSpace">{espace.procedure}</p>
                </>
              )}
            </>
          )}

          {tabKey === "calendrier" &&
            (calendrierExist(espace.email) ? (
              <ComponentCalendrier calendrier={calendrierFiltre(espace.email)} />
            ) : (
              t("public.pageTierslieux.pasCalendrier")
            ))}
        </div>
      </Card.Body>
    </Card>
  );
};

export default ComponentEspaceInfo;
